import { BenefitDTO, BikeBenefitDetailsDTO, BikeBenefitDetailsDTOEmployerExtrasEnum } from 'probonio-shared-ui/api';
import { BENEFIT_PICTURES } from 'probonio-shared-ui/component/button';
import {
  BenefitListItemExtensionInterface,
  BenefitListItemProps,
} from '../../../extension/interface/benefit-list-item.extension.interface';
import { getBenefitIcon } from '../../benefit/BenefitIcon';

export class BikeBenefitListItemExtension extends BenefitListItemExtensionInterface {
  isHidden(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[], context?: Record<string, unknown>): boolean {
    return false;
  }

  getListItemProps(activeBenefit: BenefitDTO, activeBenefits: BenefitDTO[]): BenefitListItemProps {
    const detailsBike = activeBenefit.details as BikeBenefitDetailsDTO;

    const serviceAmount = detailsBike.employerExtras.includes(BikeBenefitDetailsDTOEmployerExtrasEnum.Inspection)
      ? detailsBike.activeContract?.monthlyServiceRate || 0
      : 0;

    const insuranceAmount = detailsBike.employerExtras.includes(BikeBenefitDetailsDTOEmployerExtrasEnum.Insurance)
      ? detailsBike.activeContract?.monthlyInsuranceRate || 0
      : 0;

    const total = serviceAmount + insuranceAmount + detailsBike.employerGrant;

    return {
      icon: getBenefitIcon(activeBenefit.benefit),
      titleKey: `benefit.${activeBenefit.benefit}.${detailsBike.activeContract ? 'name' : 'nameNoContract'}`,
      navigateTo: '/bike',
      picture: BENEFIT_PICTURES[activeBenefit.benefit],
      descriptionKey: `benefitModule:benefit.${activeBenefit.benefit}.${
        detailsBike.activeContract && total > 0 ? 'description' : 'descriptionNoContract'
      }`,
      descriptionValues: { total },
      benefitProgress: detailsBike.activeContract ? 100 : 0,
    };
  }
}
